import { render } from "./AdPlacementBlock.vue?vue&type=template&id=6d7e0d08"
import script from "./AdPlacementBlock.vue?vue&type=script&lang=js"
export * from "./AdPlacementBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/AdPlacementBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d7e0d08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d7e0d08', __exports__)) {
    api.reload('6d7e0d08', __exports__)
  }
  
  module.hot.accept("./AdPlacementBlock.vue?vue&type=template&id=6d7e0d08", () => {
    api.rerender('6d7e0d08', render)
  })

}


export default __exports__